import axiosInstance from "./index.services";

export async function CricketUserExportCSV(params?: any) {
  const res = await axiosInstance.get(`/cricket-user/export-csv`, {
    params,
    responseType: "blob",
  });
  return res;
}
